module.exports = __webpack_public_path__ + "static/media/partner_image_circle.10fc8ffb.svg";